export default __webpack_public_path__ + "static/media/about-bg.7ec8bb7f.jpg";